export const salesPopNames: string[] = [
  'María',
  'Carolina',
  'Valentina',
  'Daniela',
  'Mariela',
  'Paula',
  'Rocío',
  'Fernanda',
  'Andrea',
  'Luciana',
  'Gabriela',
  'Sofía',
  'Camila',
  'Natalia',
  'Verónica',
  'Ximena',
  'Julieta',
  'Alejandra',
  'Patricia',
  'Marcela',
  'Isabel',
  'Lorena',
  'Silvia',
  'Mónica',
  'Adriana',
  'Claudia',
  'Beatriz',
  'Florencia',
  'Guadalupe',
  'Renata',
  'Pilar',
  'Elena',
  'Tamara',
  'Carla',
  'Liliana',
  'Estefanía',
  'Yolanda',
  'Noelia',
  'Cecilia',
  'Bárbara',
]

export const salesPopCities: string[] = [
  'Ciudad de México',
  'Guadalajara',
  'Monterrey',
  'Bogotá',
  'Medellín',
  'Lima',
  'Santiago',
  'Buenos Aires',
  'Córdoba',
  'Montevideo',
  'Quito',
  'Guayaquil',
  'Asunción',
  'La Paz',
  'Panamá',
  'San José',
  'Santo Domingo',
  'Caracas',
  'San Juan',
  'Madrid',
]
